export const ButtonTypes = Object.freeze({
    RESET: 'Reset',
    NEXT: 'Next',
    SAVE: 'Save',
  });
  